(() => {
  'use strict';
  const root = document.getElementById('usk-root');
  if (!root) return;
  const config = JSON.parse(document.getElementById('usk-config').textContent);
  config.eyeAvailable = config.eyeAvailable && config.offerReady === true;
  const q = (s) => root.querySelector(s);
  const qa = (s) => [...root.querySelectorAll(s)];
  const money = cents => new Intl.NumberFormat('en-US', {style:'currency',currency:config.currency || 'USD'}).format(cents / 100);
  const checkbox = q('input[type=checkbox]');
  const modal = q('#usk-modalOpen');
  const gallery = q('#gal-track');
  let busy = false, added = false, lastFocus, lastScroll;
  function show(state, visible) {qa(`[data-state="${state}"]`).forEach(e => e.hidden = !visible);}
  function bind(key, value) {qa(`[data-bind="${key}"]`).forEach(e => e.textContent = value);}
  function update() {
    const eye = checkbox.checked && config.eyeAvailable;
    const total = config.kitPrice + (eye ? config.eyePrice : 0);
    bind('orderTotal', money(total));
    bind('ctaLabel', busy ? 'Adding…' : added ? 'View your cart' : config.kitAvailable ? `Try Risk-Free - ${money(total)}` : 'Sold out');
    bind('ctaLabelShort',`Try Risk-Free - ${money(total)}`);
    bind('cbMark',eye ? '✓' : '');
    const mark=q('[data-bind=cbMark]');mark.parentElement.style.background=eye?'#525920':'transparent';
    bind('modalBtnLabel',!config.eyeAvailable?'Currently unavailable':eye?'Remove eye serum':`Add eye serum · ${money(config.eyePrice)}`);
    checkbox.disabled = busy || !config.eyeAvailable;
    qa('[data-action=toggleAddon]').forEach(e=>e.disabled=busy || !config.eyeAvailable);
    qa('[data-action=addToCart]').forEach(e=>e.disabled=busy || !config.kitAvailable);
    show('cartLoading',busy);show('addonUnavailable',!config.eyeAvailable);
  }
  function closeModal(){modal.hidden=true;document.body.style.overflow='';lastFocus?.focus();update();}
  function openModal(){lastFocus=document.activeElement;modal.hidden=false;document.body.style.overflow='hidden';q('[data-action=closeModal]').focus();update();}
  checkbox.addEventListener('change',()=>{added=false;show('cartSuccess',false);update();});
  async function purchase(){
    if(busy)return;
    if(added){location.assign('/cart');return;}
    busy=true;show('cartError',false);update();
    try{
      const items=[{id:config.kitId,quantity:1}];
      if(checkbox.checked && config.eyeAvailable)items.push({id:config.eyeId,quantity:1});
      const response=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
      const result=await response.json();
      if(!response.ok)throw new Error(result.description || 'Unable to add to cart.');
      added=true;
      bind('successMessage','Added to your cart.');show('cartSuccess',true);
      // Shopify applies the real configured offer before showing the cart.
      const target=checkbox.checked ? `/discount/${encodeURIComponent(config.discountCode)}?redirect=%2Fcart` : '/cart';
      location.assign(target);
    }catch(error){
      const alert=q('[data-state=cartError] [role=alert] span');
      if(alert)alert.textContent=error.message+' Please check your cart before retrying.';
      show('cartError',true);
    }finally{busy=false;update();}
  }
  root.addEventListener('click',event=>{
    const acc=event.target.closest('[data-accordion]');
    if(acc){const panel=document.getElementById(acc.dataset.accordion);panel.hidden=!panel.hidden;acc.setAttribute('aria-expanded',String(!panel.hidden));const icon=acc.querySelector('[data-acc-icon]') || acc.lastElementChild;if(icon)icon.textContent=panel.hidden?'+':'−';return;}
    const dot=event.target.closest('[data-gallery-index]');
    if(dot){gallery.scrollTo({left:Number(dot.dataset.galleryIndex)*gallery.clientWidth,behavior:'smooth'});return;}
    const control=event.target.closest('[data-action]');if(!control)return;
    const action=control.dataset.action;
    if(action==='scrimClick' && event.target!==control)return;
    if(action==='galNext' || action==='galPrev')gallery.scrollBy({left:gallery.clientWidth*(action==='galNext'?1:-1),behavior:'smooth'});
    if(action==='openModal')openModal();
    if(action==='closeModal' || action==='scrimClick')closeModal();
    if(action==='toggleAddon' && control!==checkbox){checkbox.checked=!checkbox.checked;added=false;update();}
    if(action==='addToCart')purchase();
  });
  gallery.addEventListener('scroll',()=>{cancelAnimationFrame(lastScroll);lastScroll=requestAnimationFrame(()=>{const index=Math.round(gallery.scrollLeft/gallery.clientWidth);qa('[data-gallery-index]').forEach(e=>e.setAttribute('aria-pressed',String(Number(e.dataset.galleryIndex)===index)));});},{passive:true});
  document.addEventListener('keydown',event=>{
    if(modal.hidden)return;
    if(event.key==='Escape'){closeModal();return;}
    if(event.key==='Tab'){
      const controls=[...modal.querySelectorAll('button:not(:disabled),a[href],input:not(:disabled)')];
      const first=controls[0],last=controls.at(-1);
      if(event.shiftKey && document.activeElement===first){event.preventDefault();last.focus();}
      else if(!event.shiftKey && document.activeElement===last){event.preventDefault();first.focus();}
    }
  });
  window.addEventListener('pageshow',()=>{busy=false;update();});
  update();
})();
